import * as React from "react"
import type { IconProps } from "../types"

const LineChart = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", size = 24, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        ref={ref}
        viewBox="0 0 24 24"
        {...props}
      >
        <path
          stroke={color}
          strokeLinecap="square"
          strokeWidth={2}
          d="M9 11V16M14 5V16M19 13V16M4 4V20H21"
        />
      </svg>
    )
  }
)
LineChart.displayName = "LineChart"

export default LineChart
